<template>
  <kudo-card>
    <kudo-block class="flex flex-col gap-y-4">
      <div class="flex justify-between items-center">
        <p class="font-medium text-base">
          Perils
        </p>
        <nuxt-link :to="PERILS_STEP_PATH">
          <kudo-button
            color-variant="flat"
            shape-variant="thin"
            class="!p-1 !py-0"
          >
            <i class="far fa-edit" />
            Edit
          </kudo-button>
        </nuxt-link>
      </div>
      <kudo-attribute
        label-text="Perils"
        class="flex flex-col"
      >
        {{ formattedPerils }}
      </kudo-attribute>
    </kudo-block>
  </kudo-card>
</template>

<script setup>
import { KudoCard, KudoButton, KudoBlock, KudoAttribute } from '@openly-engineering/kudo'
import { PERILS_STEP_PATH } from './cat-tag-utils'

const { $store } = useNuxtApp()
const perilsFormData = computed(() => $store.getters['adminClaims/getFormDataByStepPath'](PERILS_STEP_PATH))
const perilsLookupMap = computed(() => $store.getters['adminClaims/perilsLookup'])

const formattedPerils = computed(() => {
  const perilLabels = perilsFormData.value.perilUuids.map(uuid => perilsLookupMap.value.get(uuid))
  return perilLabels.join(', ')
})
</script>
